import { section } from "@/js/glow";
import { qs } from "@fluorescent/dom";

section("navbar-meganav", {
  onLoad() {
    this.LargeProductSlider = qs('.meganav__tertiary .meganav__large-prod-slider', this.container);
    if (this.LargeProductSlider) {
      this._initCarousel({
        container: '.meganav__large-prod-slider .swiper',
        navigationNext: '.meganav__large-prod-slider [data-next]',
        navigationPrev: '.meganav__large-prod-slider [data-prev]',
        pagination: '.meganav__large-prod-slider--pagination',
        perView: 4,
        tabletPerView: 3,
        mobilePerView: 2,
        mobileSpace: 16,
        desktopSpace: 24
      });
    }
  },

  _initCarousel(selectors) {
    const loadSwiper = () => {
      import(/* @vite-ignore */ flu.chunks.swiper).then(({ Swiper, Navigation, Pagination }) => {
        const swiperOptions = {
          modules: [Navigation, Pagination],
          slidesPerView: selectors.mobilePerView,
          spaceBetween: selectors.mobileSpace,
          navigation: {
            nextEl: selectors.navigationNext,
            prevEl: selectors.navigationPrev,
          },
          pagination: {
            el: selectors.pagination,
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            720: {
              spaceBetween: selectors.mobileSpace,
              slidesPerView: selectors.tabletPerView,
            },
            1100: {
              spaceBetween: selectors.desktopSpace,
              slidesPerView: selectors.perView,
            },
          },
        };
    
        new Swiper(selectors.container, swiperOptions);
      });
    };

    loadSwiper();
  },
});